import Config from "./config.js"

export default {
    /**
     * การแปลงเส้นทางรูปภาพ
     * @param {String} img_path ที่อยู่รูปภาพ
     * @param {Object} params พารามิเตอร์，สําหรับผลิตภัณฑ์、รูปภาพในอัลบั้มแยกความแตกต่างระหว่างขนาดใหญ่ กลาง และเล็ก，size: big、mid、small
     */
    img(img_path, params) {
        var path = ""
        if (img_path != undefined && img_path != "") {
            if (params && img_path != vue.$store.getters.defaultGoodsImage) {
                // กรองพล็อตเริ่มต้น
                let arr = img_path.split(".")
                let suffix = arr[arr.length - 1]
                arr.pop()
                arr[arr.length - 1] = arr[arr.length - 1] + "_" + params.size.toUpperCase()
                arr.push(suffix)
                img_path = arr.join(".")
            }
            if (img_path.indexOf("http://") == -1 && img_path.indexOf("https://") == -1) {
                path = Config.imgDomain + "/" + img_path
            } else {
                path = img_path
            }
        }
        return path
    },
    /**
     * การประทับเวลาเป็นรูปแบบวันที่
     * @param {Object} timeStamp
     */
    timeStampTurnTime(timeStamp) {
        if (timeStamp != undefined && timeStamp != "" && timeStamp > 0) {
            var date = new Date()
            date.setTime(timeStamp * 1000)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? "0" + m : m
            var d = date.getDate()
            d = d < 10 ? "0" + d : d
            var h = date.getHours()
            h = h < 10 ? "0" + h : h
            var minute = date.getMinutes()
            var second = date.getSeconds()
            minute = minute < 10 ? "0" + minute : minute
            second = second < 10 ? "0" + second : second
            return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
        } else {
            return ""
        }
    },
    /**
     * การนับถอยหลัง
     * @param {Object} seconds ที่สอง
     */
    countDown(seconds) {
        let [day, hour, minute, second] = [0, 0, 0, 0]
        if (seconds > 0) {
            day = Math.floor(seconds / (60 * 60 * 24))
            hour = Math.floor(seconds / (60 * 60)) - day * 24
            minute = Math.floor(seconds / 60) - day * 24 * 60 - hour * 60
            second = Math.floor(seconds) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day < 10) {
            // day = '0' + day
        }
        if (hour < 10) {
            // hour = '0' + hour
        }
        if (minute < 10) {
            // minute = '0' + minute
        }
        if (second < 10) {
            // second = '0' + second
        }
        return {
            d: day,
            h: hour,
            i: minute,
            s: second
        }
    },
    /**
     * การขจัดข้อมูลซ้ําซ้อนของค่า
     * @param {Array} arr อาร์เรย์
     * @param {string} field สนาม
     */
    unique(arr, field) {
        const res = new Map()
        return arr.filter(a => !res.has(a[field]) && res.set(a[field], 1))
    },
    /**
     * กําหนดว่าค่าอยู่ในอาร์เรย์หรือไม่
     * @param {Object} elem
     * @param {Object} arr
     * @param {Object} i
     */
    inArray: function(elem, arr) {
        return arr == null ? -1 : arr.indexOf(elem)
    },
    /**
     * รับวันที่ของวัน
     * @param {Object} day
     */
    getDay: function(day) {
        var today = new Date()
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetday_milliseconds)

        const doHandleMonth = function(month) {
            var m = month
            if (month.toString().length == 1) {
                m = "0" + month
            }
            return m
        }

        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()
        var tWeek = today.getDay()
        var time = parseInt(today.getTime() / 1000)
        tMonth = doHandleMonth(tMonth + 1)
        tDate = doHandleMonth(tDate)

        const week = ["วันอาทิตย์", "วันจันทร์", "วันอังคาร", "วันพุธ", "วันพฤหัสบดี", "วันศุกร์", "วันเสาร์"]
        return {
            t: time,
            y: tYear,
            m: tMonth,
            d: tDate,
            w: week[tWeek]
        }
    },
    /**
     * ลอก
     * @param {Object} message
     * @param {Object} callback
     */
    copy(value, callback) {
        var oInput = document.createElement("input") //สร้างที่ซ่อนinput（สำคัญ！）
        oInput.value = value //การมอบหมาย
        document.body.appendChild(oInput)
        oInput.select() // เลือกวัตถุ
        document.execCommand("Copy") // ดําเนินการคําสั่งคัดลอกเบราว์เซอร์
        oInput.className = "oInput"
        oInput.style.display = "none"
        vue.$message({
            message: "สําเนาสําเร็จแล้ว",
            title: 'เรียบร้อยแล้ว',type: "success"
        })
        typeof callback == "function" && callback()
    },
    /**
     * คัดลอกวัตถุแบบลึก
     * @param {Object} obj
     */
    deepClone(obj) {
        const isObject = function(obj) {
            return typeof obj == "object"
        }

        if (!isObject(obj)) {
            throw new Error("obj ไม่ใช่วัตถุ！")
        }
        //ตรวจสอบว่า วัตถุหรืออาร์เรย์จะเข้ามา
        let isArray = Array.isArray(obj)
        let cloneObj = isArray ? [] : {}
        //ผ่านfor...inเพื่อคัดลอก
        for (let key in obj) {
            cloneObj[key] = isObject(obj[key]) ? this.deepClone(obj[key]) : obj[key]
        }
        return cloneObj
    },
		
		// กรองราคา
		filterPrice(value){
			return value.toFixed(2)
		}
}
